module.exports = __webpack_public_path__ + "static/img/6bg_1.0e694b5.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/6bg_1.png
// module id = 735
// module chunks = 1